// Author thq
// Date 2022-04-20 11:43:54

import * as model from "@/model/em/statusCollection/ImfEmSicEqStatusMoniRecoIesmrModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfEmSicEqStatusMoniRecoIesmr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
